import {
  formatDateTime,
  TouringCardTable,
  TouringCardTableBody,
  TouringCardTableRow,
  TouringCardTableRowLabel,
  TouringCardTableRowValue,
} from '@common';
import { Button, Group, Modal } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { ContactCardCopyButton } from './components';

const TRANS_PATH = 'COMPANY_LINKS.CONTACT_CARD';

type ContactCardModalContactCardType = {
  shareUrl: string;
  createdAt: string;
  hits: number;
  vcardDownloads: number;
  lastAccessAt: string | null;
};

type ContactCardModalPropsType = {
  opened: boolean;
  onClose: () => void;
  onWithdraw: () => void;
  onRegenerate: () => void;
  contactCard: ContactCardModalContactCardType;
};

export const ContactCardModal: React.FC<ContactCardModalPropsType> = ({
  opened,
  onClose,
  onWithdraw,
  onRegenerate,
  contactCard,
}) => {
  const { t } = useTranslation('personDetailsGeneral');
  const noDataPlaceholder = t('NO_DATA_PLACEHOLDER', { ns: 'common' });

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={t(`${TRANS_PATH}.TITLE`)}
      size="lg"
    >
      <TouringCardTable>
        <TouringCardTableBody>
          <TouringCardTableRow>
            <TouringCardTableRowLabel>
              {t(`${TRANS_PATH}.SHARE_URL`)}
            </TouringCardTableRowLabel>
            <TouringCardTableRowValue>
              <Group gap="xs" wrap="nowrap">
                {contactCard.shareUrl}
                <ContactCardCopyButton value={contactCard.shareUrl} />
              </Group>
            </TouringCardTableRowValue>
          </TouringCardTableRow>
          <TouringCardTableRow>
            <TouringCardTableRowLabel>
              {t(`${TRANS_PATH}.HITS`)}
            </TouringCardTableRowLabel>
            <TouringCardTableRowValue>
              {contactCard.hits}
            </TouringCardTableRowValue>
          </TouringCardTableRow>
          <TouringCardTableRow>
            <TouringCardTableRowLabel>
              {t(`${TRANS_PATH}.VCARD_DOWNLOADS`)}
            </TouringCardTableRowLabel>
            <TouringCardTableRowValue>
              {contactCard.vcardDownloads}
            </TouringCardTableRowValue>
          </TouringCardTableRow>
          <TouringCardTableRow>
            <TouringCardTableRowLabel>
              {t(`${TRANS_PATH}.CREATED_AT`)}
            </TouringCardTableRowLabel>
            <TouringCardTableRowValue>
              {formatDateTime(contactCard.createdAt)}
            </TouringCardTableRowValue>
          </TouringCardTableRow>
          <TouringCardTableRow>
            <TouringCardTableRowLabel>
              {t(`${TRANS_PATH}.LAST_ACCESS`)}
            </TouringCardTableRowLabel>
            <TouringCardTableRowValue>
              {contactCard.lastAccessAt
                ? formatDateTime(contactCard.lastAccessAt)
                : noDataPlaceholder}
            </TouringCardTableRowValue>
          </TouringCardTableRow>
        </TouringCardTableBody>
      </TouringCardTable>
      <Group justify="flex-end" mt="md">
        <Button onClick={onRegenerate}>{t(`${TRANS_PATH}.REGENERATE`)}</Button>
        <Button color="red" onClick={onWithdraw}>
          {t(`${TRANS_PATH}.WITHDRAW`)}
        </Button>
      </Group>
    </Modal>
  );
};
